import { Divider, Box, Body, Icon } from '@hover/blueprint';
import React from 'react';
import { iArrowUp } from '@hover/icons';
import { ContactUs } from '..';
import { useBackToTop } from '../../../hooks';

const HelpFulLinksTabletDesktop: React.FC = () => {
  const { showButton, backToTop } = useBackToTop();

  return (
    <Box w="276px" flexDir="column" alignItems="flex-start">
      <Divider
        borderColor="neutral.300"
        my={0}
        borderWidth="1px"
        borderTopWidth={0}
        mb={500}
      />
      <ContactUs />
      <Divider
        borderColor="neutral.300"
        mt={500}
        mb={600}
        borderWidth="1px"
        borderTopWidth={0}
      />
      {showButton && (
        <Box cursor="pointer" onClick={backToTop} alignItems="center">
          <Body color="primary.600" isSemiBold>
            Back to top
          </Body>
          <Icon
            ml={200}
            strokeWidth="2px"
            size="default"
            icon={iArrowUp}
            color="primary.600"
          />
        </Box>
      )}
    </Box>
  );
};

export default HelpFulLinksTabletDesktop;
